import React from 'react';
import PropTypes from 'prop-types';

const RightArrowWithShadow = ({ fill = 'var(--SECONDARY_DARK)' }) => (
  <svg
    width="44"
    height="44"
    viewBox="0 0 44 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_7826_108394)">
      <circle r="12" transform="matrix(-1 0 0 1 22 19)" fill="white" />
    </g>
    <path
      d="M21.0704 22.8326C20.8472 23.0558 20.4854 23.0558 20.2623 22.8326C20.0508 22.6212 20.0397 22.2854 20.2289 22.0609L20.2623 22.0245L23.2866 19L20.2623 15.9755C20.0508 15.7641 20.0397 15.4282 20.2289 15.2037L20.2623 15.1674C20.4737 14.956 20.8095 14.9448 21.034 15.134L21.0704 15.1674L24.499 18.5959C24.7104 18.8074 24.7215 19.1432 24.5323 19.3677L24.499 19.4041L21.0704 22.8326Z"
      fill={fill}
    />
    <defs>
      <filter
        id="filter0_d_7826_108394"
        x="0"
        y="0"
        width="44"
        height="44"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="3" />
        <feGaussianBlur stdDeviation="5" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.168627 0 0 0 0 0.176471 0 0 0 0 0.258824 0 0 0 0.14 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_7826_108394"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_7826_108394"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

RightArrowWithShadow.propTypes = {
  fill: PropTypes.string,
};

export default RightArrowWithShadow;
